import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FocusManagerService {
  constructor() {}

  focusOnErrorInput() {
    const inputArray: HTMLIonInputElement[] = [];
    const inputElements = document.querySelectorAll('ion-input');
    inputElements.forEach((inputEle) => {
      const ionItemElement = inputEle.parentElement!;
      const ionNoteElement = ionItemElement.querySelector('ion-note');

      if (ionNoteElement) {
        inputArray.push(inputEle);
      }
    });

    if (inputArray.length > 0) inputArray[0].setFocus();
  }
}
